import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { MissionPageWrapper } from '../../Containers/Mission/MissionPageWrapper'
import { Header } from '../../Containers/Mission/Header'
import {
  MissionDetails,
  MissionCosts,
  MissionAmbassador,
} from '../../Containers/Mission/Details'
import { EditMissionDetails } from '../../Containers/Form/Mission/EditMissionDetails'
import { showUnbookModal } from '../../Reducers/UI/actions'
import UnbookModal from '../../Components/UnbookModal/container/UnbookModal'
import { notifySuccessfullySpiedMissions } from '../../Module/graphQL'
import { OnsiteManagerReport } from './Details/OnsiteManagerReport'
import { authorization } from '../../Module/Auth/Auth'
import { NotAuthorised } from '../../Components/Page/NotAuthorised'

class MissionView extends PureComponent {
  state = {
    isLoading: false,
    isCityManagerAssistant: authorization.isCityManagerAssistant(),
    isSpyRole: authorization.isSpy(),
  }

  onNotifyMissionWasSpied = async () => {
    this.setState({ isLoading: true })
    const missionId = this.props.mission.id
    const response = await notifySuccessfullySpiedMissions([missionId])
    const result = await response.json()
    if (result['errorMessage']) alert(result['errorMessage'])
    else if (result.errors && result.errors[0]) alert(result.errors[0].message)
    else {
      //TODO
      //this.props.getMissionById(missionId, {
      //  onSuccess: () => this.setState({ isLoading: false }),
      //})
    }
  }

  render = () => {
    const {
      editMode,
      deprecatedMission,
      onDeleteMission,
      mission,
      campaign,
      cityPlan,
      location,
      city,
      isCityManager,
      isClientInUSAorCA,
    } = this.props

    if (editMode) {
      if (this.state.isSpyRole) {
        return <NotAuthorised {...this.props} />
      }

      return (
        <MissionPageWrapper>
          <Header
            {...this.props}
            deleteAction={onDeleteMission}
            editMode
            location={location}
            mission={{
              ...mission,
              campaign: campaign,
              cityPlan: {
                cityPlan,
                city,
              },
            }}
          />
          <EditMissionDetails
            {...this.props}
            mission={{ ...this.props.mission, ...deprecatedMission }}
            campaign={campaign}
          />
          <UnbookModal mission={this.props.mission} />
        </MissionPageWrapper>
      )
    }

    return (
      <MissionPageWrapper>
        <Header
          {...this.props}
          mission={{
            ...this.props.mission,
            timeRangeStart: mission.dateTime,
            campaign: campaign,
            cityPlan: {
              cityPlan,
              city,
            },
          }}
          location={this.props.location}
          showUnbookModal={args =>
            this.props.showUnbookModal({
              ...args,
              onConfirm: () => this.props.onUnbook(args),
            })
          }
          showUndoDisqualificationModal={() =>
            this.props.onUndoDisqualification()
          }
          deleteAction={onDeleteMission}
        />
        <MissionDetails
          mission={{ ...this.props.mission, ...deprecatedMission }}
          campaign={campaign}
        />
        {!this.state.isCityManagerAssistant && !this.state.isSpyRole ? (
          <MissionCosts mission={deprecatedMission} />
        ) : null}
        {deprecatedMission.user && (
          <MissionAmbassador
            mission={deprecatedMission}
            onNotifyMissionWasSpied={this.onNotifyMissionWasSpied}
            isLoading={this.state.isLoading}
          />
        )}
        {(isCityManager || isClientInUSAorCA) && mission.spyInformation && (
          <OnsiteManagerReport
            cityId={city.id}
            mission={mission}
            isCityManager={isCityManager}
          />
        )}
        <UnbookModal
          mission={this.props.deprecatedMission}
          history={this.props.history}
        />
      </MissionPageWrapper>
    )
  }
}

MissionView.defaultProps = {
  editMode: false,
}

export default connect(
  null,
  {
    showUnbookModal,
  },
)(MissionView)
